import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Workbench from '@/views/Workbench.vue'
// 接口测试
import SIFtest from '@/views/SIFtest.vue'

//合同模板
import ContractTemplate from '@/views/ContractTemplate.vue'
import DownloadTemplate from '@/views/pages/template/DownloadTemplate.vue'



// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error => error)
// }
Vue.use(VueRouter)

export default new VueRouter({
  routes: [{
      path: "/siftest",
      components: {
        body: SIFtest
      }
    },
    {
      path: '/',
      redirect: '/workbench',
    },
    {
      path: '/popularize',
      component: resolve => require(['@/views/popularize.vue'], resolve),
    },
    {
      path: '/activateAuthentication',
      component: resolve => require(['@/views/activateAuthentication.vue'], resolve),
    },
    {
      path:'/privacyProtocol',
      component: resolve => require(['@/views/privacyProtocol.vue'], resolve),

    },{
      path:'/video',
      component: resolve => require(['@/views/videoSeal.vue'], resolve),

    },
    {
      path:'/userProtocol',
      component: resolve => require(['@/views/userProtocol.vue'], resolve),

    },
    {
      path:'/sdkdoc',
      name: 'SdkDoc',
      component: resolve => require(['@/views/docs/sdk-doc.vue'], resolve),

    },
    {
      path: '/enterprise',
      component: resolve => require(['@/views/enterprise.vue'], resolve),
      children: [{
        path:'enterprise_authe',
        name:'enterprise_authe',
        component: resolve => require(['@/views/enterpriseCertification/enterprise_authe.vue'], resolve),
      },{
        path:'personal_authentication',
        name:'personal_authentication',
        component: resolve => require(['@/views/personalAuthentication/personal_authentication.vue'], resolve),
      }]

    },
    {
      path:'/acounts',
      component: resolve => require(['@/views/account/AccountOne.vue'], resolve),
      children:[{
        path: 'login',
        name: 'login',
        component: resolve => require(['@/views/account/Login.vue'], resolve),
      },{
        path: 'activation',
        name: 'activation',
        component: resolve => require(['@/views/account/activation.vue'], resolve),
      },]
    },
    {
      path: '/account',
      component: resolve => require(['@/views/account/Account.vue'], resolve),
      children: [{
        path: '',
        name: 'registerSelect',
        component: resolve => require(['@/views/account/RegisterSelect.vue'], resolve),
      }, {
        path: 'register/:type/:fromPromoCode',
        name: 'register',
        component: resolve => require(['@/views/account/Register.vue'], resolve),
      }, {
        path: 'cgEmail',
        name: 'cgEmail',
        component: resolve => require(['@/views/account/CgEmail.vue'], resolve),
      }, {
        path: 'cgPassword',
        name: 'cgPassword',
        component: resolve => require(['@/views/account/CgPassword.vue'], resolve),
      }, {
        path: 'cgPhone',
        name: 'cgPhone',
        component: resolve => require(['@/views/account/CgPhone.vue'], resolve),
      },
      {
        path: 'forgetPassword',
        name: 'forgetPassword',
        component: resolve => require(['@/views/account/ForgetPassword.vue'], resolve),
      },
      {
        path: 'modifyPassword',
        name: 'modifyPassword',
        component: resolve => require(['@/views/account/modifyPassword.vue'], resolve),
      },
      {
        path: 'ModifyMobilePhone',
        name: 'ModifyMobilePhone',
        component: resolve => require(['@/views/account/ModifyMobilePhone.vue'], resolve),
      },
      {
        path: 'ModifyMailbox',
        name: 'ModifyMailbox',
        component: resolve => require(['@/views/account/ModifyMailbox.vue'], resolve),
      }]
    },
    {
      path: '/',
      name: 'signature',
      component: resolve => require(['@/views/signature.vue'], resolve),
      children: [{
        path:'signature_of_documents',
        name:'signature_of_documents',
        component: resolve => require(['@/views/signature_of_documents.vue'], resolve),
      },{
        path:'authorized_seal',
        name:'authorized_seal',
        component: resolve => require(['@/views/authorized/authorized_seal.vue'], resolve),
      }]

    },

    {
      path: '/',
      name: 'home',
      component: resolve => require(['@/views/Home.vue'], resolve),
      children: [{
        path: 'workbench',
        component: resolve => require(['@/views/Workbench.vue'], resolve),
        children: [{
          path: '',
          redirect: 'signDocument'
        }
          ,{
            path: 'signDocument',
            name: 'signDocument',
            component: resolve => require(['@/views/pages/workbench/SignDocument.vue'], resolve),
          },{
          path: 'signDocument/local_file/:test/:id/:type/:pdfFileSaveId',
          name: 'local_file',
          component: resolve => require(['@/views/pages/workbench/local_file.vue'], resolve),
        }]
      }, {
        path: 'user',
        component: resolve => require(['@/views/UserManage.vue'], resolve),
        children: [ {
          path: '',
          redirect: 'accountBaseInfo'
        }, {
          path: 'accountBaseInfo',
          component: resolve => require(['@/views/pages/user/AccountBaseInfo.vue'], resolve),
        }, {
          path: 'mySignature',
          name: 'mySignature',
          component: resolve => require(['@/views/pages/user/MySignature.vue'], resolve),
        }, {
          path: 'contacts',
          component: resolve => require(['@/views/pages/user/Contacts.vue'], resolve),
        }, {
          path: 'mySetMeal',
          name: 'mySetMeal',
          component: resolve => require(['@/views/pages/user/MySetMeal.vue'], resolve)
        }, {
          path: 'myOrder',
          name: 'myOrder',
          component: resolve => require(['@/views/pages/user/myOrder.vue'], resolve)
        }, {
          path: 'myOrder/apply_for_invoice/:id/:orderCode/:orderAmount',
          name: 'apply_for_invoice',
          component: resolve => require(['@/views/pages/user/apply_for_invoice.vue'], resolve)
        }, {
          path: 'myOrder/xq_invoice/:invoiceId/:id',
          name: 'xq_invoice',
          component: resolve => require(['@/views/pages/user/xq_invoice.vue'], resolve)
        },
        {
          path: 'mySetMeal/buyMeal',
          name:"buyMeal",
          component: resolve => require(['@/views/pages/user/meal/BuyMeal.vue'], resolve),
        },{
          path: 'mySetMeal/paymentMethod/:code',
          name:"paymentMethod",
          component: resolve => require(['@/views/pages/user/meal/paymentMethod.vue'], resolve),
        },{
          path: 'mySetMeal/pay_window/:radio1/:id',
          name:"pay_window",
          component: resolve => require(['@/views/pages/user/meal/pay_window.vue'], resolve),
        },{
          path: 'myAuth',
          component: resolve => require(['@/views/pages/user/MyAuth.vue'], resolve),
        },{
          path: 'myAuth/authorized_person',
          name: 'authorized_person',
          component: resolve => require(['@/views/pages/user/myAuthorized/authorized_person.vue'], resolve),
        }, {
          path: 'feedback',
          component: resolve => require(['@/views/pages/user/Feedback.vue'], resolve),
        },
        {
          path: 'accountBaseInfo/enterpriseAuthe',
          name:"enterpriseAuthe",
          component: resolve => require(['@/views/pages/user/authentication/EnterpriseAuthe.vue'], resolve),
        },
        {
          path: 'accountBaseInfo/personalAuthentication',
          name:"personalAuthentication",
          component: resolve => require(['@/views/pages/user/authentication/personalAuthentication.vue'], resolve),
        }
      ]
      }, {
        path: 'document',
        component: resolve => require(['@/views/MyDocument.vue'], resolve),
        children: [ {
          path: '',
          redirect: 'all_information'
        },{
          path: ':status',
          component: resolve => require(['@/views/pages/document/Doc4All.vue'], resolve),
        },
        {
          path: ':status/details',
          component: resolve => require(['@/views/pages/document/DocDetails.vue'], resolve),
        }]
      },
        {
          path: 'Viewcertificate',
          name:'Viewcertificate',
          component: resolve => require(['@/views/Viewcertificate.vue'], resolve),
        }
      ]
    },
    

  ]
})

